const form2 = {
  formId2: "new-user-form-2",
  formField2: {
    quarter: {
      name: "quarter",
      label: "[01] Kỳ tính thuế: Quý",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập quý",
    },
    year: {
      name: "year",
      label: "Năm",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập năm",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[04] Tên tổ chức nhận tái bảo hiểm nước ngoài hoặc tổ chức được uỷ quyền:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
  },
};

export default form2;
